<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  locked: { type: Boolean, default: false },
  error: { type: String, default: '' },
  identity: { type: Object, default: () => ({}) },
});

const emit = defineEmits(['update']);
const { t } = useI18n();
</script>

<template>
  <div class="grid gap-3" data-test="sales-party-representative-roles">
    <div class="flex flex-wrap gap-x-4 gap-y-2">
      <label
        class="flex h-9 items-center rounded-[10px] px-[15px] text-base"
        :class="
          locked || identity.is_legal_representative
            ? 'bg-[#EDF8F7] text-[#009F94]'
            : 'text-[#464F53]'
        "
      >
        <input
          type="checkbox"
          class="mr-2 h-[18px] w-[18px] accent-[#01988C]"
          :checked="locked || Boolean(identity.is_legal_representative)"
          :disabled="locked"
          @change="
            emit('update', 'is_legal_representative', $event.target.checked)
          "
        />
        {{ t('SALES_PARTIES.FORM.LEGAL_REPRESENTATIVE') }}
      </label>
      <label
        class="flex h-9 items-center rounded-[10px] px-[15px] text-base"
        :class="
          locked || identity.is_partner
            ? 'bg-[#EDF8F7] text-[#009F94]'
            : 'text-[#464F53]'
        "
      >
        <input
          type="checkbox"
          class="mr-2 h-[18px] w-[18px] accent-[#01988C]"
          :checked="locked || Boolean(identity.is_partner)"
          :disabled="locked"
          @change="emit('update', 'is_partner', $event.target.checked)"
        />
        {{ t('SALES_PARTIES.FORM.PARTNER') }}
      </label>
    </div>
    <p
      v-if="error"
      role="alert"
      class="flex items-center gap-1 text-xs text-lais-danger"
      data-test="sales-party-representative-roles-error"
    >
      <span class="i-lucide-circle-alert size-4" aria-hidden="true" />
      {{ error }}
    </p>
  </div>
</template>
